import { Time } from './types';
import { useNavigate } from 'react-router-dom';

interface ControlButtonsProps {
  isClockShowing: boolean;
  isPaused: boolean;
  time: Time;
  wakeLock: any;
  setWakeLock: (v: any) => void;
  setTime: (fn: any) => void;
  setIsClockShowing: (v: boolean) => void;
  setIsPaused: (v: boolean) => void;
  startFunc: (seconds: number) => void;
  worker: Worker | null;
  isSubmitting: boolean;
  setIsSubmitting: (v: boolean) => void;
  setIsEndSessionScreenOpen: (v: boolean) => void;
}

const ControlButtons = ({
  time,
  wakeLock,
  setWakeLock,
  setIsClockShowing,
  isClockShowing,
  isPaused,
  setIsPaused,
  startFunc,
  worker,
  isSubmitting,
  setIsEndSessionScreenOpen,
  setTime,
}: ControlButtonsProps) => {
  const navigate = useNavigate();

  const pause = () => {
    worker?.postMessage({ type: 'stop' });
    setTime((current: Time) => ({
      ...current,
      initialMinutes: Math.ceil(current.secondsRemaining / 60),
    }));
    setIsClockShowing(false);
    setIsPaused(true);
    if (wakeLock) {
      wakeLock.release().then(() => setWakeLock(null));
    }
  };

  return (
    <div className="flex w-full gap-3 mb-1">
      <button
        disabled={isSubmitting}
        className="flex-1 py-3 rounded-lg text-white font-semibold bg-orange-500 hover:bg-orange-600 transition disabled:opacity-50"
        onClick={() => {
          if (time.totalSessionTime > 0) {
            setIsEndSessionScreenOpen(true);
            pause();
          } else {
            navigate('/dashboard');
          }
        }}
      >
        End
      </button>

      {isClockShowing ? (
        <button
          className="flex-1 py-3 rounded-lg font-semibold bg-parchment-200 hover:bg-parchment-300 text-ink transition"
          onClick={pause}
        >
          Pause
        </button>
      ) : (
        <button
          disabled={isSubmitting}
          className="flex-1 py-3 rounded-lg text-parchment-100 font-semibold bg-leather hover:bg-leather-light transition disabled:opacity-50"
          onClick={() => startFunc(time.secondsRemaining)}
        >
          {isPaused ? 'Resume' : 'Start'}
        </button>
      )}
    </div>
  );
};

export default ControlButtons;
